var _rect, _defs, _title;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "#068fe0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "#068fe0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_2",
    x1: 0.96875,
    y1: 0.985156238079071,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_3",
    x1: 0.54296875,
    y1: 0.699999988079071,
    x2: 0.32421875,
    y2: 0.30546873807907104
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#044266",
    stopOpacity: 0.9921875,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#043f60",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_6",
    x1: 0.20703125,
    y1: 0.879687488079071,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05405e",
    stopOpacity: 0.984375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_7",
    x2: 0.171875,
    y2: 0.965624988079071,
    x1: 1,
    y1: 0.985156238079071
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07354f",
    stopOpacity: 0.9921875,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_8",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064266",
    stopOpacity: 0.9921875,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0693e5",
    stopOpacity: 0.9921875,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_9",
    x2: 0,
    y2: 1,
    x1: 1,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19bee8",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053c8e",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_10",
    x2: 0.57421875,
    y2: 0.817187488079071,
    x1: 1,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19bee8",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053c8e",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_11",
    x1: 0.31640625,
    y1: 1,
    x2: 0.796875,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a1baf",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19b4e8",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_12",
    x1: 1,
    y1: 0.981249988079071,
    x2: 0.296875,
    y2: 0.832812488079071
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_13",
    x2: 1,
    y2: 1,
    x1: 0.45703125,
    y1: 0.805468738079071
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_14",
    x2: 1,
    y2: 0,
    x1: 0.625,
    y1: 0.762499988079071
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_15",
    x2: 0.76171875,
    y2: 0.617968738079071,
    x1: 0.94140625,
    y1: 0.18046873807907104
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg_16",
    x2: 0.921875,
    y2: 0.17265623807907104,
    x1: 0.65234375,
    y1: 0.672656238079071
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03507d",
    stopOpacity: 0.99609375,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#068fe0",
    stopOpacity: 0.99609375,
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg_16)",
    d: "M72.2,20.9 C78.3,23.8 82.4,31 79.1,36.8 C75.7,42.6 65,47 63.2,54.8 C61.4,62.7 68.6,74 67.8,76.2 C67.1,78.4 58.6,71.5 50.1,71.3 C41.7,71.1 33.4,77.7 27.8,77.1 C22.1,76.5 19.2,68.7 17.200000000000003,61.1 C15.299999999999997,53.4 14.299999999999997,45.7 16.4,39 C18.5,32.2 23.5,26.3 29.6,23.5 C35.7,20.6 42.8,20.7 50.5,20.1 C58.1,19.5 66.2,18 72.2,20.9 z",
    width: "100%",
    height: "100%",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    },
    id: "svg_1",
    className: "selected",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.a4d69b33bec78d3fd75811a0916efc19.svg";
export { ForwardRef as ReactComponent };